import React from 'react';
import { useTranslation } from 'react-i18next';
import { FeverUiLocaleProvider } from '@fever/ui';

/**
 * Bridges new-canvas-admin's react-i18next locale into `@fever/ui`'s locale
 * Context, so any composed library component (Media Manager, future
 * DatePicker, etc.) inside this subtree auto-inherits the current locale.
 */
export default function ProviderFeverUi({ children, locale }) {
    const { i18n } = useTranslation();
    const resolvedLocale = locale ?? i18n.language;
    return <FeverUiLocaleProvider locale={resolvedLocale}>{children}</FeverUiLocaleProvider>;
}
